@if (!control.element.visibility && control.element.isVisible !== false) {
  <div [style.padding-left.px]="control.element.paddingLeft">
    @switch (control.element.type) {
      @case ('title') {
        <h1 style="color: #000;">{{ control.element.label }}</h1>
      }
      @case ('html') {
        <p style="color: black" [innerHTML]="control.element.label"></p>
      }
      @case ('file') {
        <p style="color: black" [innerHTML]="control.element.label"></p>
        <app-file-upload-v2 [fileControl]="control"></app-file-upload-v2>
      }
      @case ('radio_large') {
        <app-radio-lg-button [formGroup]="formGroup" [control]="control"></app-radio-lg-button>
      }
      @case ('address_lookup') {
        <p style="color: black" [innerHTML]="control.element.label"></p>
        <app-address-search [control]="control" [viewModel]="viewModel"></app-address-search>
        <div style="padding-bottom: 10px"></div>
      }
      @case ('existing_address') {
        <app-existing-address [control]="control" [viewModel]="viewModel"></app-existing-address>
      }
      @case ('button_reset_fields') {
        <app-button-reset-fields [control]="control" [controlCache]="controlCache"></app-button-reset-fields>
      }
      @case ('validation') {
        <app-control-error-list [control]="control"></app-control-error-list>
      }
      @case ('group_validation') {
        <app-form-group-errors [inputForm]="formGroup"></app-form-group-errors>
      }
      @case ('grid') {
        <app-control-grid [control]="control"
          [pageFormGroup]="formGroup"
          [viewModel]="viewModel"
          [controls]="controlCache">
        </app-control-grid>
      }
      @case ('radio') {
        <p style="color: black; margin-bottom: 0">{{ control.element.label }} <span
        class="color-red">{{ control.isRequired() ? '*' : '' }}</span></p>
        @for (option of control.element.options; track option) {
          <div>
            <div class="form-check">
              <input type="radio" [name]="control.element.id" [id]="option.id" [formControl]="control.AsTyped"
                class="form-check-input" [value]="option.id">
                <label class="form-check-label" style="color: black" [for]="option.id">{{ option.label }}</label>
              </div>
            </div>
          }
        }
        @case ('checkbox') {
          <div class="form-check">
            <input [id]="control.element.id"
              class="form-check-input"
              type="checkbox"
              value=""
              [formControl]="control.AsTyped">
              <label class="form-check-label"
                [for]="control.element.id"
              style="color: black">{{ control.element.option }}</label>
              <app-control-error-list [control]="control"></app-control-error-list>
            </div>
          }
          <!-- Separate switch to optimize label/error list wrapping -->
          @default {
            <app-dynamic-form-label [arrayIndex]="arrayIndex" [control]="control"></app-dynamic-form-label>

            @switch (control.element.type) {
              @case ('personal_property') {
                <app-personal-property-input [control]="control"></app-personal-property-input>
              }
              @case ('text') {
                <input type="text"
                  [id]="control.element.id"
                  [formControl]="control.AsTyped"
                  [class]="formHelper.getValidIndicator(control)"
                  [placeholder]="control.element.placeholder"
                  [readOnly]="control.element.readOnly === true"
                  [ngbTooltip]="getTooltip(control)">
                }
                @case ('textarea') {
                  <textarea [rows]="3"
                    [maxlength]="control.element.maxLength"
                    [id]="control.element.id"
                    [formControl]="control.AsTyped"
                    [class]="formHelper.getValidIndicator(control)"
                    [placeholder]="control.element.placeholder"
                    [readOnly]="control.element.readOnly === true"
                  [ngbTooltip]="getTooltip(control)"></textarea>
                }
                @case ('ain') {
                  <input type="text"
                    [id]="control.element.id"
                    [formControl]="control.AsTyped"
                    [class]="formHelper.getValidIndicator(control)"
                    [placeholder]="control.element.placeholder"
                    appNumericSplitter
                    [splitterType]="SplitterType.AIN"
                    [readOnly]="control.element.readOnly === true">
                  }
                  @case ('zip') {
                    <input type="text"
                      [id]="control.element.id"
                      [formControl]="control.AsTyped"
                      [class]="formHelper.getValidIndicator(control)"
                      [placeholder]="control.element.placeholder"
                      appNumericSplitter
                      [splitterType]="SplitterType.ZIP"
                      [readOnly]="control.element.readOnly === true">
                    }
                    @case ('ssn') {
                      <app-ssn-input [control]="control"></app-ssn-input>
                    }
                    @case ('phone') {
                      <input type="text"
                        [id]="control.element.id"
                        [formControl]="control.AsTyped"
                        [class]="formHelper.getValidIndicator(control)"
                        [placeholder]="control.element.placeholder"
                        autocomplete="tel"
                        [readonly]="control.element.readOnly === true"
                        appNumericSplitter
                        [splitterType]="SplitterType.PHONE"
                        [ngbTooltip]="getTooltip(control)">
                      }
                      @case ('date') {
                        <input type="date"
                          [formControl]="control.AsTyped"
                          [id]="control.element.id"
                          [class]="formHelper.getValidIndicator(control)">
                        }
                        @case ('select_state') {
                          <app-select-state [control]="control" [formGroup]="formGroup"></app-select-state>
                        }
                        @case ('select-state') {
                          <app-select-state [control]="control" [formGroup]="formGroup"></app-select-state>
                        }
                        @case ('select') {
                          <app-form-select [control]="control" [formGroup]="formGroup"></app-form-select>
                        }
                        @case ('currency') {
                          <input [formControl]="control.AsTyped"
                            [id]="control.element.id"
                            currencyMask
                            class="form-control"
                            [options]="{prefix: '$', thousands: ',', decimal: '.', allowNegative: false, allowZero: true, align: 'right'}"/>
                          }
                          @case ('number') {
                            <input type="number"
                              [formControl]="control.AsTyped"
                              [id]="control.element.id"
                              [class]="formHelper.getValidIndicator(control)"
                              [placeholder]="control.element.placeholder"
                              [readOnly]="control.element.readOnly === true"
                              [ngbTooltip]="getTooltip(control)">
                            }
                            @default {
                              <p>Unknown control of type {{ control.element.type }}</p>
                            }
                          }

                          <app-control-error-list [control]="control"></app-control-error-list>
                        }
                      }
                    </div>
                  }
